export default class BasicAPI {
    /**
     * Единый интерфейс валидации полей API для playwright
     * @param page {Page}
     * @param expect {Expect<{}>}
     * @param route {Route}
     * @param request {APIRequestContext}
     * @param test {TestType<PlaywrightTestArgs & PlaywrightTestOptions, PlaywrightWorkerArgs & PlaywrightWorkerOptions>}
     * @return Promise<void>
     */
    async validate({page, expect, route, request, test}) {
        throw new Error('Not implemented');
    }
}

export class Warning extends BasicAPI {
    constructor(warning) {
        super();
        /**
         * @type {String}
         */
        this.item = warning.item;
        /**
         * @type {Number}
         */
        this.itemid = warning.itemid;
        /**
         * @type {String}
         */
        this.message = warning.message;
        /**
         * @type {String}
         */
        this.warningcode = warning.warningcode;
    }

    get itemId() {
        return this.itemid;
    }

    get warningCode() {
        return this.warningcode;
    }

    /**
     * Единый интерфейс валидации полей API для playwright
     * @param expect {Expect<{}>}
     * @return Promise<void>
     */
    validate({expect}) {
        expect(this.item).toBeTruthy();
        expect(this.warningCode).toBeTruthy();
        expect(this.message).toBeTruthy();
    }
}
